import { Typography, Grid } from "@mui/material";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { MdEmail } from "react-icons/md";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import TextInputWithIcon from "../../main/components/TextInputIcon";
import { useNavigate } from "react-router-dom";
import BaseButton from "../../main/components/BaseButton";
import { usersApi } from "../../services/api";
import { emailRegex } from "../../main/utils/utils";

const schema = yup.object().shape({
  email: yup
    .string()
    .matches(emailRegex, "Forato de email inválido")
    .required("Necessário informar o e-mail"),
});

export type RecoveryPasswordData = yup.InferType<typeof schema>;
export default function PasswordRecovery() {
  const [loading, setLoading] = useState<boolean>(false);
  const navigate = useNavigate();

  const onSubmit = async (data: RecoveryPasswordData) => {
    try {
      setLoading(true);
      await usersApi.resetPassword(data.email);
      navigate("sucesso");
    } catch (error) {
      navigate("erro");
    } finally {
      setLoading(false);
    }
  };
  const {
    control,
    formState: { errors },
    handleSubmit,
  } = useForm({
    resolver: yupResolver(schema),
  });

  const handleButtonBack = () => {
    navigate("/login");
  };
  return (
    <Grid
      rowGap={2}
      component="form"
      onSubmit={(e) => {
        e.preventDefault();
        handleSubmit(onSubmit)();
      }}
      justifyContent={"center"}
      alignItems={"center"}
      container
      maxWidth={"400px"}
    >
      <Grid item xs={10}>
        <Typography variant="h6">Esqueceu sua senha ou usuário?</Typography>
      </Grid>
      <Grid item xs={10}>
        <Typography>Informe abaixo o e-mail vinculado a sua conta:</Typography>
      </Grid>
      <Grid item xs={10}>
        <TextInputWithIcon
          required
          label="Email"
          fieldName="email"
          control={control}
          errors={errors}
          style={{ width: "100%" }}
          startIcon={<MdEmail />}
        />
      </Grid>
      <Grid item xs={10}>
        <BaseButton
          type="submit"
          loading={loading}
          title="Enviar"
          endIcon={<ArrowForwardIcon />}
        />
      </Grid>
      <Grid xs={10} item justifyContent="center">
        <BaseButton
          type="button"
          onClick={() => handleButtonBack()}
          title="Voltar para tela de login"
        />
      </Grid>
    </Grid>
  );
}
